import { Button, Card, CardContent, CardFooter, CardHeader, CardTitle, Form } from '@/shared/components';
import { useTemplateMetadataForm } from '../hooks/useTemplateMetadataForm';
import type { DocumentTemplateDetail } from '../types/documentTemplates.types';
import { TemplateMetadataFields } from './TemplateMetadataFields';

interface Props {
  template: DocumentTemplateDetail;
  canEdit: boolean;
}

export function TemplateMetadataForm({ template, canEdit }: Props) {
  const { form, submit, discard, isDirty, isSaving } = useTemplateMetadataForm(template);

  return (
    <Card>
      <Form onSubmit={submit}>
        <CardHeader>
          <CardTitle>Template details</CardTitle>
          <p className="mt-1 text-sm text-mp-muted">
            Metadata only. The document content is edited on the Draft tab and goes live when published.
          </p>
        </CardHeader>
        <CardContent className="grid gap-x-6 gap-y-5 py-6 sm:grid-cols-2">
          <TemplateMetadataFields
            control={form.control}
            disabled={!canEdit}
          />
        </CardContent>
        {canEdit && (
          <CardFooter>
            <Button type="button" variant="neutral" appearance="outline" size="sm" onClick={discard} disabled={!isDirty || isSaving}>
              Discard changes
            </Button>
            <Button type="submit" size="sm" disabled={isSaving}>
              {isSaving ? 'Saving...' : 'Save details'}
            </Button>
          </CardFooter>
        )}
      </Form>
    </Card>
  );
}
